import type { ReactNode } from 'react';

const MARK_SIZE = 32;
const GRADIENT_ID = 'brief-mark-gradient';
const GLYPH = '#DA8662';
const KNOCKOUT = '#F3D1C3';

export function BriefMark(): ReactNode {
  return (
    <svg
      width={MARK_SIZE}
      height={MARK_SIZE}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      focusable="false"
      style={{ flexShrink: 0 }}
    >
      <rect width="32" height="32" rx="9" fill={`url(#${GRADIENT_ID})`} />
      <path opacity="0.2" d="M23.2725 12.5385H18.1816V7.69238L23.2725 12.5385Z" fill={GLYPH} />
      <path
        d="M23.7873 12.0487L18.6964 7.2025C18.6288 7.13823 18.5485 7.08727 18.4603 7.05252C18.372 7.01778 18.2774 6.99993 18.1818 7H9.45455C9.06878 7 8.69881 7.14588 8.42603 7.40554C8.15325 7.66521 8 8.01739 8 8.38462V23.6154C8 23.9826 8.15325 24.3348 8.42603 24.5945C8.69881 24.8541 9.06878 25 9.45455 25H22.5455C22.9312 25 23.3012 24.8541 23.574 24.5945C23.8468 24.3348 24 23.9826 24 23.6154V12.5385C24.0001 12.4475 23.9813 12.3575 23.9448 12.2734C23.9083 12.1894 23.8548 12.113 23.7873 12.0487ZM18.9091 9.36337L21.5173 11.8462H18.9091V9.36337ZM22.5455 23.6154H9.45455V8.38462H17.4545V12.5385C17.4545 12.7221 17.5312 12.8982 17.6676 13.028C17.8039 13.1578 17.9889 13.2308 18.1818 13.2308H22.5455V23.6154Z"
        fill={GLYPH}
      />
      <path
        d="M18.7002 21.418C19.0633 21.418 19.4101 21.5468 19.6836 21.7754L19.7959 21.8789L19.8975 21.9932C20.1195 22.2695 20.2402 22.6144 20.2402 22.9688C20.2402 23.2694 20.1523 23.5626 19.9902 23.8135C20.1872 23.8672 20.3911 23.8978 20.5977 23.8984H20.6162C21.2402 23.9 21.8437 23.6511 22.2949 23.1992L22.5879 22.9062H22.71C22.7403 22.8914 22.7704 22.8761 22.8018 22.8633L22.9463 22.8125C23.0928 22.769 23.2456 22.7473 23.3994 22.749L23.5527 22.7588C23.6539 22.7702 23.7538 22.7911 23.8506 22.8223L23.9932 22.877L24.1299 22.9443C24.2186 22.994 24.3019 23.0523 24.3789 23.1182L24.4893 23.2227L24.5889 23.3369C24.6825 23.4559 24.7581 23.5878 24.8135 23.7285C24.8872 23.916 24.9241 24.1164 24.9219 24.3174C24.9196 24.518 24.8785 24.7167 24.8008 24.9023C24.7231 25.0877 24.6089 25.2564 24.4658 25.3994L24.4668 25.4004C23.4424 26.4261 22.0592 27.0019 20.6152 26.999V27H20.5879C19.5643 26.9975 18.5735 26.7023 17.7197 26.165C17.6927 26.1976 17.6656 26.2303 17.6357 26.2607C17.3485 26.5536 16.9548 26.7217 16.54 26.7217C16.1253 26.7217 15.7316 26.5536 15.4443 26.2607C15.1578 25.9685 15 25.5759 15 25.1709V22.9688C15 22.5637 15.1578 22.1712 15.4443 21.8789C15.7316 21.5861 16.1253 21.418 16.54 21.418H18.7002ZM20.4131 16C21.4361 16.0029 22.4261 16.298 23.2793 16.835C23.3064 16.8023 23.3343 16.7699 23.3643 16.7393L23.4766 16.6357C23.7501 16.4072 24.0969 16.2783 24.46 16.2783C24.8747 16.2783 25.2684 16.4464 25.5557 16.7393C25.8422 17.0315 26 17.4241 26 17.8291V20.0312C26 20.4363 25.8422 20.8288 25.5557 21.1211C25.2684 21.4139 24.8747 21.582 24.46 21.582H22.2998C21.8851 21.582 21.4913 21.414 21.2041 21.1211C20.9175 20.8288 20.7598 20.4363 20.7598 20.0312C20.7598 19.7305 20.8466 19.4365 21.0088 19.1855C20.8867 19.1522 20.7622 19.1274 20.6357 19.1143L20.4014 19.1016H20.3828C19.7591 19.1003 19.156 19.3492 18.7051 19.8008L18.7041 19.8018C18.4135 20.0915 18.0174 20.2557 17.6025 20.251C17.1878 20.2462 16.7956 20.0734 16.5117 19.7773C16.2286 19.482 16.0756 19.0875 16.0801 18.6826C16.0846 18.2779 16.2465 17.8876 16.5361 17.5986C17.5605 16.5736 18.9432 15.998 20.3867 16.001V16H20.4131Z"
        fill={GLYPH}
        stroke={KNOCKOUT}
        strokeWidth="2"
      />
      <defs>
        <linearGradient
          id={GRADIENT_ID}
          x1="1"
          y1="1"
          x2="32"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF6F3" />
          <stop offset="1" stopColor="#EAB8A2" />
        </linearGradient>
      </defs>
    </svg>
  );
}
